/* eslint-disable @typescript-eslint/no-empty-function */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef } from 'react';
import { Callout, CommandBar, CommandBarButton, DirectionalHint, mergeStyleSets } from '@fluentui/react';
import * as PropTypes from 'prop-types';
const contentStyles = mergeStyleSets({
    reviewButtonsStack: {
        padding: 0
    },
    markedAsHelpfulThanksCallout: {
        padding: '8px 24px'
    }
});
export const AppReviewItemToolbar = ({ onToggleComments = ()=>{}, onReportAbuse = ()=>{}, onMarkAsHelpful = ()=>{}, review, isMarkedAsHelpful = false, showMarkAsHelpfulThanks }, context)=>{
    const markAsHelpfulButtonRef = useRef(null);
    const toolbarButtonsContainerRef = useRef(null);
    const initializeItems = useCallback(()=>{
        const items = [];
        items.push({
            key: 'markAsHelpful',
            onClick: onMarkAsHelpful,
            iconProps: {
                iconName: !isMarkedAsHelpful ? 'Like' : 'LikeSolid'
            },
            text: context.locParams('ReviewItem_MarkAsHelpfulButton_Label', [
                review.mark_as_helpful_count.toString()
            ], 'Mark as helpful ({0})'),
            commandBarButtonAs: ({ key, onClick, iconProps, text })=>{
                const buttonProps = {
                    key,
                    role: 'button',
                    onClick,
                    iconProps,
                    text,
                    elementRef: markAsHelpfulButtonRef
                };
                return /*#__PURE__*/ _jsx(CommandBarButton, _object_spread_props(_object_spread({}, buttonProps), {
                    role: "menuitem"
                }));
            }
        });
        items.push({
            key: 'comments',
            onClick: onToggleComments,
            iconProps: {
                iconName: 'Chat'
            },
            text: context.locParams('ReviewItem_CommentsButton_Label', [
                review.comments_count.toString()
            ], 'Comments ({0})')
        });
        items.push({
            key: 'report',
            onClick: onReportAbuse,
            iconProps: {
                iconName: 'Flag'
            },
            text: context.loc('ReportButton_Label', 'Report review')
        });
        return items;
    }, [
        isMarkedAsHelpful,
        onMarkAsHelpful
    ]);
    const items = initializeItems();
    return /*#__PURE__*/ _jsxs("div", {
        className: "appReviewButtons",
        ref: toolbarButtonsContainerRef,
        children: [
            /*#__PURE__*/ _jsx(CommandBar, {
                items: items,
                overflowButtonProps: {
                    menuProps: {
                        isBeakVisible: false,
                        items: []
                    }
                },
                styles: {
                    root: contentStyles.reviewButtonsStack
                }
            }),
            showMarkAsHelpfulThanks && /*#__PURE__*/ _jsx(Callout, {
                directionalHint: DirectionalHint.topCenter,
                className: contentStyles.markedAsHelpfulThanksCallout,
                target: markAsHelpfulButtonRef.current ? markAsHelpfulButtonRef : toolbarButtonsContainerRef,
                doNotLayer: true,
                children: context.loc('ReviewItem_MarkAsHelpful_Submitted_Thanks_Label', 'Thank you')
            })
        ]
    });
};
AppReviewItemToolbar.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    reportAbuseCallback: PropTypes.func
};
